import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { fetchBlogPost } from "@/lib/apiData";

export default function BlogPost() {
  const { slug } = useParams();
  const { data: post, isLoading } = useQuery({ queryKey: ["blog", slug], queryFn: () => fetchBlogPost(slug), retry: false });

  if (isLoading) {
    return <div className="min-h-[50vh] flex items-center justify-center"><div className="w-8 h-8 border-2 border-[#d00000] border-t-transparent rounded-full animate-spin" /></div>;
  }
  if (!post) {
    return (
      <div className="max-w-3xl mx-auto px-5 py-32 text-center" data-testid="blog-not-found">
        <h1 className="font-display text-3xl text-neutral-900">Story not found</h1>
        <Link to="/discovery" className="text-[#d00000] mt-4 inline-block">Back to stories</Link>
      </div>
    );
  }

  return (
    <div data-testid="blog-post-page">
      <section className="relative h-[50vh] min-h-[340px]">
        <img src={post.cover} alt={post.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/20" />
        <div className="absolute bottom-0 left-0 right-0 p-8">
          <div className="max-w-3xl mx-auto">
            <Link to="/discovery" className="inline-flex items-center gap-2 text-sm text-neutral-200 hover:text-white mb-4"><ArrowLeft className="w-4 h-4" /> All stories</Link>
            <span className="block text-xs uppercase tracking-[0.2em] text-[#f5a623]">{post.category} · {post.read}</span>
            <h1 className="font-display text-4xl sm:text-5xl font-black text-white leading-tight mt-2">{post.title}</h1>
          </div>
        </div>
      </section>
      <article className="max-w-3xl mx-auto px-5 sm:px-8 py-14">
        <p className="text-sm text-neutral-400 mb-8">By {post.author}</p>
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="font-display text-2xl leading-relaxed text-neutral-800">{post.excerpt}</motion.p>
        <p className="text-neutral-600 leading-relaxed mt-6 text-lg whitespace-pre-line">{post.body}</p>
      </article>
    </div>
  );
}
